import {
  API_VERSION,
  SUBSCRIPTION_SERVICE,
  X_API_VERSION,
} from "../../../constants";
import { apiOptions, apiRequest } from "../../../utils";

const API_TRADE = `${SUBSCRIPTION_SERVICE}/trades`;

export const trades = {
  getAll: async ({ filters, sort } = { sort: "name" }) => {
    const options = await apiOptions({
      url: `${API_TRADE}`,
      method: "get",
      filters,
      sort,
    });
    return apiRequest(options);
  },
  get: async (id) => {
    const options = await apiOptions({
      url: `${API_TRADE}/${id}`,
      method: "get",
    });
    return apiRequest(options);
  },
  create: async ({ data, toastMessageConfig }) => {
    const options = await apiOptions({
      url: API_TRADE,
      method: "post",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });
    return apiRequest(options, toastMessageConfig);
  },
  update: async ({ id, data, toastMessageConfig }) => {
    const options = await apiOptions({
      url: `${API_TRADE}/${id}`,
      method: "patch",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });

    return apiRequest(options, toastMessageConfig);
  },
  delete: async ({ id, data, toastMessageConfig }) => {
    const options = await apiOptions({
      url: `${API_TRADE}/${id}`,
      method: "delete",
      headers: { [X_API_VERSION]: API_VERSION },
      data,
    });

    return apiRequest(options, toastMessageConfig);
  },
};
